import { Instagram, ArrowUpRight } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/sixthsenseroadtrip/";
const INSTAGRAM_HANDLE = "@sixthsenseroadtrip";

export default function InstagramFollow() {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="px-6 md:px-12 -mt-6 md:-mt-12 mb-20 md:mb-28"
    >
      <div className="max-w-5xl mx-auto">
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-card"
          className="group relative block overflow-hidden border border-white/10 hover:border-white/30 bg-[#0a0a0a] transition-all duration-500 hover:-translate-y-0.5 reveal"
        >
          {/* Brand-accurate Instagram gradient wash on the right side */}
          <div
            aria-hidden="true"
            className="absolute top-0 bottom-0 right-0 w-2/3 opacity-[0.10] group-hover:opacity-[0.16] transition-opacity duration-700 pointer-events-none"
            style={{
              background:
                "radial-gradient(circle at 80% 50%, #FCAF45 0%, #E1306C 35%, #C13584 60%, #5B51D8 90%)",
            }}
          />

          <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10 px-6 md:px-10 py-8 md:py-10">
            {/* Glyph */}
            <div
              className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center"
              style={{
                background:
                  "linear-gradient(45deg, #F58529 0%, #DD2A7B 40%, #8134AF 70%, #515BD4 100%)",
              }}
            >
              <Instagram
                className="w-7 h-7 md:w-8 md:h-8 text-white"
                strokeWidth={1.75}
              />
            </div>

            {/* Copy */}
            <div className="flex-1 min-w-0">
              <div className="text-[10px] uppercase tracking-overline text-gold mb-2">
                From the road · in real time
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl text-white leading-tight tracking-tight">
                Follow the journey on Instagram
              </h3>
              <p className="mt-2 text-sm md:text-base text-zinc-400 font-light leading-relaxed">
                Latest stories, reels, and photos from the road —{" "}
                <span className="text-white">{INSTAGRAM_HANDLE}</span>.
              </p>
            </div>

            {/* CTA */}
            <div className="shrink-0 md:self-center">
              <span className="group inline-flex items-center gap-3 px-6 py-3.5 bg-white text-black text-xs uppercase tracking-overline font-medium group-hover:bg-gold transition-colors duration-300">
                Follow on Instagram
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
